import React from 'react';
import { Typography, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { makeStyles } from 'utils/makeStylesAdapter';
import { INSTALLMENT_TYPES } from 'constants/agreement/installmentTypes';

const useStyles = makeStyles({
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '40px',
  },
  radioLabel: {
    fontSize: '0.7rem',
  },
});

const InstallmentTypeRadioGroup = props => {
  const { installmentType, setInstallmentType, context } = props;
  const classes = useStyles();
  return (
    <>
      <Typography align="left" variant="h6">
        Selecione o tipo de parcelamento
      </Typography>
      <RadioGroup
        name="installmentsType"
        onChange={event => setInstallmentType(event.target.value)}
        value={installmentType}
        className={classes.radioGroup}
      >
        <FormControlLabel
          control={<Radio color="primary" />}
          label={INSTALLMENT_TYPES[context].FIXED_PER_PERIOD}
          value={INSTALLMENT_TYPES[context].FIXED_PER_PERIOD}
          classes={{ label: classes.radioLabel }}
        />
        <FormControlLabel
          control={<Radio color="primary" />}
          label={INSTALLMENT_TYPES[context].VARIABLE_PER_PERIOD}
          value={INSTALLMENT_TYPES[context].VARIABLE_PER_PERIOD}
          classes={{ label: classes.radioLabel }}
        />
        <FormControlLabel
          control={<Radio color="primary" />}
          label={INSTALLMENT_TYPES[context].PAID_BY_SPECIFIC_DATE}
          value={INSTALLMENT_TYPES[context].PAID_BY_SPECIFIC_DATE}
          classes={{ label: classes.radioLabel }}
        />
      </RadioGroup>
    </>
  );
};

export default InstallmentTypeRadioGroup;
